module.exports = __webpack_public_path__ + "static/media/I_lazy_ui.a3cb87d8.png";